import { ComponentProps } from 'react';

import { Box } from 'components/Box';
import { getStaticImageSrc } from 'utils/getImageSrc';

import { BaseLogoLegacy } from './BaseLogoLegacy';

export function IdealistLogoLegacy({
  showStaffMarker,
  ...props
}: Omit<ComponentProps<typeof BaseLogoLegacy>, 'children'> & {
  showStaffMarker?: boolean;
}) {
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <BaseLogoLegacy {...props}>
      <Box height="100%" position="relative" display="inline-block">
        <canvas width="347.913" height="167.883" />
        <Box position="absolute" top={0} left={0} width="100%" height="100%">
          <img
            src={getStaticImageSrc('icons/logo-idealist.svg')}
            alt="idealist"
          />
        </Box>
      </Box>
      {showStaffMarker && (
        <>
          <canvas width="45.976" height="167.883" />
          <Box height="100%" position="relative" display="inline-block">
            <canvas width="184.444" height="167.883" />
            <Box
              position="absolute"
              top={0}
              left={0}
              width="100%"
              height="100%"
            >
              <img
                src={getStaticImageSrc('icons/logo-staff.svg')}
                alt="staff"
              />
            </Box>
          </Box>
        </>
      )}
    </BaseLogoLegacy>
  );
}
